export default __webpack_public_path__ + "static/human-rights-campaign-f908298315e11ed14cb03991283fb6a1.svg";